/**
 * Desktop mega menu (souman-agro style): top-level nav items with children
 * get a full-width panel — subcategory rail left, newest products of the
 * hovered subcategory right (AJAX, cached, skeleton placeholders while
 * loading) with a "Bekijk alle" link.
 */
(function () {
  const nav = document.querySelector('.main-nav .main-nav__list');

  if (!nav) {
    return;
  }

  // Product previews are opt-in (phent_mega_menu_products filter →
  // data-mega-products="1" on the list, see library/menu.php). Without them
  // the CSS-only .sub-menu dropdown is all that's needed.
  if (nav.dataset.megaProducts !== '1') {
    return;
  }

  const ajaxUrl = `${window.location.origin}/wp-admin/admin-ajax.php`;
  const cache = new Map();

  const catSlug = (href) => {
    try {
      const parts = new URL(href, window.location.origin).pathname
        .split('/')
        .filter(Boolean);
      return parts[0] === 'product-categorie' ? parts[parts.length - 1] : '';
    } catch (e) {
      return '';
    }
  };

  const escapeHtml = (str) =>
    str.replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));

  const skeletons = () =>
    Array.from({ length: 4 }, () => `
      <span class="mega-menu__card">
        <span class="phent-skeleton-box block aspect-[2/3] rounded-lg mb-2"></span>
        <span class="phent-skeleton-box block h-3 w-3/4 mb-1.5"></span>
        <span class="phent-skeleton-box block h-3 w-1/3"></span>
      </span>`).join('');

  const cards = (products) => {
    if (!products.length) {
      return '<p class="mega-menu__empty">Geen producten gevonden.</p>';
    }

    return products
      .map((p) => `
        <div class="mega-menu__card group">
          <div class="relative aspect-[2/3] overflow-hidden rounded-lg border border-neutral-200 bg-neutral-100 mb-2">
            ${p.on_sale ? '<span class="pointer-events-none absolute top-2 right-2 z-10 rounded bg-red-600 px-2 py-1.5 text-white text-xs font-semibold uppercase tracking-[0.03em] leading-none">Sale</span>' : ''}
            <a href="${p.url}" class="absolute inset-0 block" aria-label="${escapeHtml(p.title)}">
              ${p.img ? `<img src="${p.img}" alt="" loading="lazy" class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105">` : ''}
            </a>
            ${p.pre_order ? '<span class="preorder-ribbon" aria-hidden="true"><span>Pre-order</span></span>' : ''}
            ${p.in_stock === false ? '<span class="pointer-events-none absolute top-1/2 -translate-y-1/2 inset-x-0 z-10 block bg-white/90 py-3 text-center font-body font-semibold text-[#222] text-base">Uitverkocht</span>' : ''}
            <button type="button" class="quick-view absolute bottom-4 left-1/2 z-10 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 hover:bg-secondary-600 px-4 py-2 text-white text-[0.8rem] font-semibold leading-none -translate-x-1/2 translate-y-[150%] opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100 cursor-pointer" data-product="${p.id}">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-3.5 h-3.5 shrink-0" aria-hidden="true"><path d="M23.271,9.419C21.72,6.893,18.192,2.655,12,2.655S2.28,6.893.729,9.419a4.908,4.908,0,0,0,0,5.162C2.28,17.107,5.808,21.345,12,21.345s9.72-4.238,11.271-6.764A4.908,4.908,0,0,0,23.271,9.419Zm-1.705,4.115C20.234,15.7,17.219,19.345,12,19.345S3.766,15.7,2.434,13.534a2.918,2.918,0,0,1,0-3.068C3.766,8.3,6.781,4.655,12,4.655s8.234,3.641,9.566,5.811A2.918,2.918,0,0,1,21.566,13.534Z"/><path d="M12,7a5,5,0,1,0,5,5A5.006,5.006,0,0,0,12,7Zm0,8a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z"/></svg>
              Snel bekijken
            </button>
          </div>
          <a href="${p.url}" class="mega-menu__card-title">${escapeHtml(p.title)}</a>
          <span class="mega-menu__card-price">${p.price || ''}</span>
        </div>`)
      .join('');
  };

  nav.querySelectorAll(':scope > li.menu-item-has-children').forEach((li) => {
    const subMenu = li.querySelector(':scope > .sub-menu');

    if (!subMenu) {
      return;
    }

    li.classList.add('has-mega');

    const mega = document.createElement('div');
    mega.className = 'mega-menu';
    mega.innerHTML = `
      <div class="mega-menu__box">
        <div class="mega-menu__rail"></div>
        <div class="mega-menu__panel">
          <div class="mega-menu__head">
            <h3 class="mega-menu__title"></h3>
            <a href="#" class="mega-menu__all"></a>
          </div>
          <div class="mega-menu__products"></div>
        </div>
      </div>`;

    mega.querySelector('.mega-menu__rail').appendChild(subMenu);
    li.appendChild(mega);

    const title = mega.querySelector('.mega-menu__title');
    const all = mega.querySelector('.mega-menu__all');
    const grid = mega.querySelector('.mega-menu__products');
    const links = [...subMenu.querySelectorAll('li > a')];
    let activeLink = null;
    let requestSeq = 0;

    const activate = (link) => {
      if (link === activeLink) {
        return;
      }

      activeLink = link;
      links.forEach((a) => a.classList.toggle('is-active', a === link));

      const label = link.textContent.trim();
      title.textContent = label;
      all.href = link.href;
      all.innerHTML = `Bekijk alle ${escapeHtml(label)}
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>`;

      const slug = catSlug(link.href);
      const seq = ++requestSeq;

      if (!slug) {
        grid.innerHTML = '';
        return;
      }

      if (cache.has(slug)) {
        grid.innerHTML = cards(cache.get(slug));
        return;
      }

      grid.innerHTML = skeletons();

      fetch(`${ajaxUrl}?action=phent_menu_products&cat=${encodeURIComponent(slug)}`)
        .then((response) => response.json())
        .then((data) => {
          const products = data.products || [];
          cache.set(slug, products);

          if (seq === requestSeq) {
            grid.innerHTML = cards(products);
          }
        })
        .catch(() => {
          if (seq === requestSeq) {
            grid.innerHTML = '';
          }
        });
    };

    links.forEach((a) => a.addEventListener('mouseenter', () => activate(a)));

    // Preload the first subcategory when the top-level item is hovered.
    li.addEventListener('mouseenter', () => {
      if (!activeLink && links.length) {
        activate(links[0]);
      }
    });
  });
})();
